
import React, { useCallback, useEffect, useMemo, useState } from 'react';

import instance from '../../../api/authentication'
import { MaterialReactTable } from 'material-react-table';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  MenuItem,
  Stack,
  TextField,
  Tooltip,
} from '@mui/material';

//example of creating a mui dialog modal for creating new rows
export const MenuCreationPage = ({ open, columns, onClose, onSubmit }) => {

    const[categotyItem,setCategoryItem]=useState([]);
   
  
    
  
    // !---======Apicall for menu submit======---!
  const handleonSubmit=(categotyItem)=>{
    console.log(categotyItem)
    const postData={
     name:categotyItem.menuName,
    
    };
   instance
    .post(`/createPage`,postData)
    .then((Response)=>{
      console.log(Response)
      onClose();
    })
  
  }
  
  
    return (
      <Dialog open={open}>
        <DialogTitle textAlign="center">Create New Menu </DialogTitle>
        <DialogContent>
          <form onSubmit={(e) => e.preventDefault()}>
            <Stack
              sx={{
                width: '100%',
                minWidth: { xs: '300px', sm: '360px', md: '400px' },
                gap: '1.5rem',
              }}
            >
                <TextField
                  // key={}
                  label='Menu Name'
                  name='menuName'
                  onChange={(e) =>
                    setCategoryItem({ ...categotyItem, [e.target.name]: e.target.value })
                  }
                />
            </Stack>
            </form>
        </DialogContent>
        <DialogActions sx={{ p: '1.25rem' }}>
          <Button onClick={onClose}>Cancel</Button>
          <Button color="secondary" onClick={()=>handleonSubmit(categotyItem)}  variant="contained">
           Submit
          </Button>
        </DialogActions>
       
      </Dialog>
    );
  };
  